import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { FaRegFileAlt, FaFileAlt } from 'react-icons/fa';

import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './FilesWorkReportApproverButton.module.scss';

const FilesWorkReportApproverButton = ({ dailyWorkReport, selectedDate, fetchData }) => {
  const { activeAttachFileModal } = useWorkReportModals();
  const setColorAttachedDocument = () => {
    if (dailyWorkReport?.requiereAdjunto) return 'danger';
    if (dailyWorkReport?.contieneAdjunto) return 'info';

    return 'dark';
  };

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Archivos">
      <div className={`d-flex justify-content-evenly ${styles.container}`}>
        <Button
          className={styles['button-with-tooltip']}
          colorIcon={setColorAttachedDocument()}
          icon={dailyWorkReport?.contieneAdjunto ? FaFileAlt : FaRegFileAlt}
          onClick={() =>
            activeAttachFileModal(
              {
                ...dailyWorkReport,
                date: selectedDate
              },
              fetchData
            )
          }
          type="button"
          variant="light"
          widthButton="30px"
        />
      </div>
    </ComponentWithTooltip>
  );
};

export default FilesWorkReportApproverButton;

FilesWorkReportApproverButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired,
  selectedDate: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};
